<div class="account-flyout">
    <div fxFlex class="account-flyout__nologin" (click)="navigateToIdam()" >
        <img
            loading="lazy"
            [src]="avatarIcon"
            class="account-flyout__avatar"
            width="24"
            height="24"
            alt="avatar"/>
          <a
          [mmTestTarget]="'login-link-desktop'"
          rel="nofollow"
          >{{'CORE.ALL_PAGES.USER_BOX.SIGNUP.LABEL' | translate}}/{{ 'CORE.ALL_PAGES.USER_BOX.LOGIN.LABEL' | translate }}</a>
      </div>
</div>
